
import { useState } from "react";
import styles from "../FieldTypeModal.module.scss";
import ToggleButton from "../../../../../../../common/components/toggle-button/ToggleButton";
import { ChoseBoolFiledConfig } from "./shared/ChooseBool";
import Button from "../../../../../../../common/components/xepp/button/Button";
import { LimitNumberAttributeFiledConfig } from "./shared/LimitNumberAttributeConfig";
import { InputWithClearFiledConfig } from "./shared/InputWithClear";
import { Attribute, FieldType, FileExtensionType, getFileExtensionTypeString } from "../../../../../../../model/service-request/attribute";
import { v4 as uuidv4 } from 'uuid';
import { toast } from "react-toastify";

type Props = {
    onFieldSave: (attr: Attribute) => void
    existingAttribute?: Attribute
}

export const FileUploadFieldConfiguration = (props: Props) => {
    const [attribute, setAttribute] = useState<Attribute>({
        id: props.existingAttribute ? props.existingAttribute.id : uuidv4(),
        label: props.existingAttribute ? props.existingAttribute.label : "",
        isRequired: props.existingAttribute ? props.existingAttribute.isRequired : false,
        isEnabled: props.existingAttribute ? props.existingAttribute.isEnabled : true,
        isLimited: props.existingAttribute ? props.existingAttribute.isLimited : false,
        maxSizeLimit: props.existingAttribute ? props.existingAttribute.maxSizeLimit : 0,
        fileExtensionTypes: props.existingAttribute ? props.existingAttribute.fileExtensionTypes ?? [] : [],
        fieldType: FieldType.File,
    });

    const clearFieldName = () =>
        setAttribute({ ...attribute, label: "" });


    return <div className={styles.rightSideBody}>
        <div className={styles.configurationForm}>
            <InputWithClearFiledConfig
                onChange={(val: string) => {
                    setAttribute({ ...attribute, label: val })

                }}
                onClear={clearFieldName}
                value={attribute.label}
                filedLabel="Field Name"
                placeholederText="Enter Field Name"
            />


            <ChoseBoolFiledConfig
                onChange={(val: boolean) => {
                    setAttribute({ ...attribute, isRequired: val });
                }
                }
                value={attribute.isRequired}
                option1="Yes"
                option2="No"
                fieldLabel={"Required"}
            />

            <LimitNumberAttributeFiledConfig label={"Max Size"}
                onIsLimitChange={(val: boolean) => {
                    let num = attribute.maxSizeLimit || undefined;
                    if (!val) {
                        num = undefined;
                    }
                    setAttribute({ ...attribute, isLimited: val, maxSizeLimit: num })

                }}
                onNumberChange={(val) => {
                    let num = val || 0;
                    setAttribute({ ...attribute, maxSizeLimit: num });
                }}
                value={attribute.maxSizeLimit}
                isLimited={attribute.isLimited ?? false}
                stepSize={1}
                minVal={1}
                unit="MB"
            />
            <div className={styles.configurationField}>
                <div className={styles.title}>
                    <span className={styles.label}>fileExtensionTypes</span>
                </div>
                <div className={`${styles.body} ${styles.wrap}`}>
                    {[
                        FileExtensionType.JPG,
                        FileExtensionType.JPEG,
                        FileExtensionType.PNG,
                        FileExtensionType.MP4,
                        FileExtensionType.DOC,
                        FileExtensionType.DOCX,
                        FileExtensionType.PDF,
                        FileExtensionType.CSV,
                    ].map((extension, i) => (
                        <div className={styles.toggleOption} key={`extension-${i}`}>
                            <span>{`.${getFileExtensionTypeString(extension)}`}</span>
                            <ToggleButton value={attribute.fileExtensionTypes?.indexOf(extension) != -1} onToggle={() => {
                                var fileExtensionTypes = attribute.fileExtensionTypes;
                                if (fileExtensionTypes?.indexOf(extension) == -1) {
                                    fileExtensionTypes = [...fileExtensionTypes, extension]
                                } else {
                                    fileExtensionTypes = fileExtensionTypes?.filter(x => x !== extension)
                                }
                                setAttribute({ ...attribute, fileExtensionTypes: fileExtensionTypes })
                            }} />
                        </div>
                    ))}

                </div>
            </div>
        </div>

        <div className={styles.saveField}>
            <Button onClick={() => {
                if (attribute.isLimited && !attribute.maxSizeLimit) {
                    toast.warning("If field has 'Max Size' value of it can't be empty");
                    return;
                } props.onFieldSave(attribute)
            }} variant="secondary" text="Save Field" className={styles.saveFieldBtn} />
        </div>
    </div>
}